export default{
  saveViewHomeWork({commit},data){
    commit('SAVE_VIEW_HOME_WORK', data)
  },
}



// WEBPACK FOOTER //
// ./src/store/axj_help/actions.js